import React, { useEffect, useRef, useState } from 'react'
import QR from './image/qr-code.png'
import { toast, ToastContainer } from 'react-toastify';
import { FaCloudUploadAlt } from "react-icons/fa";

import './App.css'
import { Api_Url } from './APIUrl';
const AddCase = () => {
 
    const [isNextClicked, setIsNextClicked] = useState(false);
    const [Data, setData] = useState([]);
  
    const handleNextClick = () => {
      setIsNextClicked(true);
    };
 
   



    const GetQr =()=>{
      try {
         
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };

fetch(`${Api_Url}api/deposit/qrcode`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    console.log(result.message,"hello")
    if(result.success == true){
      setData(result.data.qrcodes) 
    }
  })
  .catch((error) => console.error(error));


      } catch (error) {
        
      }
    }



    const [amount, setAmount] = useState("");
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName("");
    }
  };

  const submitDepositRequest = async () => {
    if (!amount || !fileInputRef.current.files[0]) {
      toast("Please enter amount and upload a screenshot.");
      return;
    }

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const formData = new FormData();
      formData.append("amount", amount);
      formData.append("payment_screenshot", fileInputRef.current.files[0]);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
      };

      const response = await fetch(`${Api_Url}api/deposit-request`, requestOptions);
      const result = await response.json();

      if (result.success) {
        toast(result.message);  
        setAmount("");
        setFileName("");
        fileInputRef.current.value = null;  
      } else {
        let errorMessage = result.error;
      
      
        if (errorMessage && typeof errorMessage === 'object') { 
          errorMessage = Object.values(errorMessage)
            .flat()  
            .join(', ');  
        }
       
        toast(errorMessage ); 
      }
    } catch (error) {
      console.error("Error:", error);
      toast("An error occurred while submitting your request.");
    }
  };


    useEffect(() => {
      GetQr()
    }, [])
    
  
  return (
    <div>
<ToastContainer/>
        <div className='container mt-5 pt-4  '   style={{height:'90vh',  }}>
            <div className='row'>
              

              {/* <div className='col-lg-12 col-sm-12'>  
      {!isNextClicked ? (
          <div className='col-lg-12 col-sm-12'>
          <div>
           <h6>Choose amount to add </h6> 
           <div class="mb-3 mt-4">
<label for="exampleInputEmail1" class="form-label">Aadhar Number</label>
<input type="number" class="form-control py-2" id="exampleInputEmail1" aria-describedby="emailHelp"  placeholder='AADHAR  NUMBER'  style={{boxShadow:'none', border:'1px solid #ffcc5b'}}/> 

<div className='mt-1'  style={{fontSize:'14px'}}>Min: 10, Max: 25000</div>
</div>

            
            <div className='card border-0' >
                <div className='card-body'>
                <div class="accordion" id="accordionExample">
                <div class="accordion-item">
<h2 class="accordion-header" id="headingOne">
<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
<span>Add to Current Balance</span>
<span style={{ display: 'flex', alignItems: 'center' }}>
  ₹100.00
  <i class="bi bi-arrow-right" style={{ marginLeft: '8px' }}></i>  
</span>
</div>
</button>
</h2>
<div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
<div class="accordion-body">


<div> 
<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
 <p className='mb-0 mb-1' style={{color:'#1a507f', fontSize:'13px'}}>Deposit Amount (excl. Govt. Tax) <span className='px-2' style={{backgroundColor:'#d8e9f9'}}>A</span></p>
 <p className='mb-0 mb-1' style={{color:'#00d2fb', fontSize:'13px'}}>₹78.13</p>
</div>

<div style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #eee'}}>
 <p  style={{color:'#1a507f', fontSize:'13px'}}>Govt. Tax. (28% GST)</p>
 <p style={{color:'#00d2fb', fontSize:'13px'}}>₹21.88</p>
</div>
        
<div className='pt-2' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
 <p className='mb-0 mb-1' style={{color:'#1a507f', fontSize:'13px'}}>Total</p>
 <p className='mb-0 mb-1'  style={{color:'#00d2fb', fontSize:'13px'}}>₹78.13</p>
</div>

<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
 <p className='mb-0 mb-1' style={{color:'#1a507f', fontSize:'13px'}}>😍 Deposit BonusB
<span className='px-2' style={{backgroundColor:'#d8e9f9'}}>B</span></p>
 <p className='mb-0 mb-1' style={{color:'#00d2fb', fontSize:'13px'}}>₹78.13</p>
</div>




<div style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #eee'}}>
 <p style={{color:'#1a507f', fontSize:'13px'}}>Add to Current Balance  <span className='px-2' style={{backgroundColor:'#d8e9f9'}}>A</span> +  <span className='px-2' style={{backgroundColor:'#d8e9f9'}}>B</span></p>
 <p style={{color:'#00d2fb', fontSize:'13px'}}>₹21.88</p>
</div>
</div>

</div>
</div>
</div>

</div>
                </div>
            </div>




            <button className="btn btn-primary py-2 w-100 mt-4" onClick={handleNextClick}>Next</button>
            </div>
    </div>
      ) : (
        <div className='col-lg-12'>

        <div className='card mt-4'   style={{backgroundColor:'#cde8f86b',borderBottom:'1px solid #cde8f8'}}>
          <div className='card-body'>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
              <h6>Amount to be added ₹100</h6>

              <button className='btn btn-primary' onClick={()=>{setIsNextClicked(isNextClicked-1)}}>Edit</button>
            </div>
          </div>
        </div>


        <div className='my-4'>
        <h6>Pay Through UPI </h6>
        </div>

        <div className='card my-4'  style={{backgroundColor:'#cde8f86b',borderBottom:'1px solid #cde8f8',boxShadow:''}}>
      
          <div className='card-body'>

            
            <div style={{display:'flex', alignItems:'center',    }}>
                <img src={img11} style={{width:'30px'}}/>
                <h6 className='ms-5 pt-2'>PayNow</h6>
            </div>
          </div>
        </div>
      </div>
      )}
    </div> */}




       <div className='card h-100 py-4  absss'   >
        <div className='card-body'>
            
        <div>
      {Data?.map((item) => (
        <div key={item.id}> 
            <h6 className='text-center'>Title: {item?.title}</h6>
          <div style={{display:'flex', justifyContent:'space-around'}}>
          <img
  src={`https://backend.brothersludo.in/storage/${item?.qr_code_image}`}
  alt="QR Code Screenshot"
  style={{ width: "45%" }}
/>

           
        </div>
        </div>
      ))}
    </div>


<div> 
</div>




        
    <div>
      {/* Amount Input */}
      <div className="mt-4">
      <label className='my-2'>Depost Amount</label>
        <input
          type="number"
          placeholder="Enter Amount"
          className="py-2"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>

      {/* File Upload */}
      <div style={styles.container}>
        {fileName && <p style={styles.fileName}>{fileName}</p>}
        <label style={styles.button}>
        <FaCloudUploadAlt  className='fs-3'/>  Upload Screenshot
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={styles.fileInput}
            onChange={handleFileChange}
          />
        </label>
      </div>

      {/* Submit Button */}
      <div style={{display:'flex', justifyContent:'center'}}> 
        <button className='btn btn-success w-75 mt-4' onClick={submitDepositRequest} style={styles.submitButton}>
          Send Request
        </button>
      </div>
    </div>



        </div> 
       </div>

        
            </div>
        </div>





    
    </div>
  )
}

 
const styles = {
  container: {
    textAlign: "center",
    marginTop: "20px",
  },
  fileName: {
    marginBottom: "10px",
    fontSize: "16px",
    color: "#333",
  },
  button: {
    display: "inline-block",
    padding: "10px 20px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
  },
  fileInput: {
    position: "absolute",
    left: 0,
    top: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
};

export default AddCase